import { create } from 'zustand'
import { immer } from "zustand/middleware/immer";

export const useGlobalCarteira = create(
  immer((set) => ({
    dataCarteira: {},
    imagemUser: null,
    setDataCarteira: (payload) => set((state) => {
      state.dataCarteira = payload;
    }),
    setImagemUser: (payload) => set((state) => {
      state.imagemUser = payload;
    }),
  }))
);